import { render, staticRenderFns } from "./BairrosTodos.vue?vue&type=template&id=06f8631f"
import script from "./BairrosTodos.vue?vue&type=script&lang=js"
export * from "./BairrosTodos.vue?vue&type=script&lang=js"
import style0 from "./BairrosTodos.vue?vue&type=style&index=0&id=06f8631f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports